// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4c-1";
export var standaloneTable = "_4c-0";